module.exports = __webpack_public_path__ + "static/media/verticalDots.b1b6adb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/think/verticalDots.svg
// module id = 1896
// module chunks = 0